import React, {useState} from 'react';
import { SvgIcon } from '..';
import { Link } from 'react-router-dom';
import './DetailsBox.scss';

const DetailsBox = ({ title, subtitle, subtitlelink, children, className }) => {
    const [isActive, setActive] = useState("false");
    const handleToggle = () => {
        setActive(!isActive);
      };
    return (
        <div className={`${"detail-box-wrapper"} ${className}`}>
            <div className="detail-box-inner">
                <div className="detailbox-title" onClick={handleToggle}>
                    <div>SENTINEL EXPLORER</div>
                    <div className="title-icon">{isActive ? '-' : '+'}</div>
                </div>
                <div className={isActive ? "detailbox-content" : "detailbox-content hide"}>
                    {subtitle && (
                        <div className="subtitle">
                            <Link to={subtitlelink}><SvgIcon name="arrow-left" viewbox="0 0 16.368 10.916" /> </Link> {subtitle}
                        </div>
                    )}
                    <div className="detailbox-content-inner">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetailsBox
